import React, { useEffect, useRef, useState } from 'react';
import { Modal, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { EnhancedViewer } from '@partsbadger/threedviewer';

interface ThreeDViewerModalProps {
    url: string | null;
    visible: boolean;
    onClose: () => void;
    loading: boolean;
}

const ThreeDViewerModal: React.FC<ThreeDViewerModalProps> = ({ url, visible, onClose, loading }) => {
    const [viewerSession, setViewerSession] = useState(0);
    const wasVisibleRef = useRef(false);
    useEffect(() => {
        if (visible && !wasVisibleRef.current) {
            setViewerSession(s => s + 1);
        }
        wasVisibleRef.current = visible;
    }, [visible]);

    const showViewer = Boolean(visible && url);
    return (
        <Modal
            open={visible}
            footer={null}
            centered={true}
            width="95vw"
            maskClosable={true}
            onCancel={onClose}
            bodyStyle={{ height: '80vh', margin: 0, padding: 0, overflow: 'hidden' }}
            style={{ maxWidth: '1200px' }}
        >
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                {showViewer && (
                    <>
                        <EnhancedViewer key={`${url}-${viewerSession}`} url={url!} />
                        {loading && (
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'rgba(0,0,0,0.35)',
                                    zIndex: 20,
                                }}
                            >
                                <Spin indicator={<LoadingOutlined />} tip="Loading 3D Model..." />
                            </div>
                        )}
                    </>
                )}
                {!showViewer && loading && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <Spin indicator={<LoadingOutlined />} tip="Loading 3D Model..." />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ThreeDViewerModal;
